<script lang="ts">
import IconCollapse from '@/components/icons/IconCollapse.svelte'
import IconExpand from '@/components/icons/IconExpand.svelte'
import Tooltip from '@/components/Tooltip.svelte'
import { testIds } from '@/constants'
import IconButton from '@/core/IconButton.svelte'
import { isMessengerFrameExpanded, setMessengerFrameExpanded } from '@/modules/frames'
import { widgetOptions } from '@/modules/options'
import { t } from '@/modules/translations'

import BasicButtons from './WidgetHeaderBasicButtons.svelte'

const { orientation, widgetBlockingOptions } = widgetOptions.getOptions()

const handleExpandClick = () => {
	setMessengerFrameExpanded(true)
}
const handleCollapseClick = () => {
	setMessengerFrameExpanded(false)
}

const { buttonCollapseChat, buttonExpandChat } = testIds
</script>

<div class="h-32px flex mx-2 mt-2 justify-between overflow-hidden">
	<div>
		{#if $isMessengerFrameExpanded}
			<Tooltip content={$t('tooltip.collapse')} placement="bottom" delay={1000}>
				<IconButton
					icon={IconCollapse}
					iconDescription="Collapse"
					iconOrientation={orientation}
					onClick={handleCollapseClick}
					testId={buttonCollapseChat}
					disabled={widgetBlockingOptions?.disableExpandButton}
				/>
			</Tooltip>
		{:else}
			<Tooltip content={$t('tooltip.expand')} placement="bottom" delay={1000}>
				<IconButton
					icon={IconExpand}
					iconDescription="Expand"
					iconOrientation={orientation}
					onClick={handleExpandClick}
					testId={buttonExpandChat}
					disabled={widgetBlockingOptions?.disableExpandButton}
				/>
			</Tooltip>
		{/if}
	</div>
	<BasicButtons />
</div>
